// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

export const caseManagerCensus$ = (state) =>
  get(state, ['reports', 'caseManagerCensus'], {})

export const summaryList$ = createSelector(
  caseManagerCensus$,
  ({ summaryList = [] }) => summaryList
)

export const detailedList$ = createSelector(
  caseManagerCensus$,
  ({ detailedList = [] }) => detailedList
)
